import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Sparkles, Sun, Leaf, Gift, Star } from "lucide-react";
import { getActivePromo, SeasonalPromo } from "@/lib/seasonal-promos";

export const SeasonalBanner = () => {
  const [promo, setPromo] = useState<SeasonalPromo | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const activePromo = getActivePromo();
    if (activePromo) {
      setPromo(activePromo);
      const dismissed = sessionStorage.getItem(`dismissed_promo_${activePromo.id}`);
      if (!dismissed) {
        setIsVisible(true);
      }
    }
  }, []);

  if (!isVisible || !promo) return null;

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem(`dismissed_promo_${promo.id}`, "true");
  };

  const getIcon = () => {
    switch (promo.theme) {
      case "spring": return <Sparkles className="h-4 w-4 mr-2" />;
      case "summer": return <Sun className="h-4 w-4 mr-2 text-yellow-300" />;
      case "fall": return <Leaf className="h-4 w-4 mr-2 text-orange-300" />;
      case "holiday": return <Gift className="h-4 w-4 mr-2 text-red-300" />;
      case "newyear": return <Star className="h-4 w-4 mr-2 text-yellow-200" />;
      default: return <Sparkles className="h-4 w-4 mr-2" />;
    }
  };

  const getBgColor = () => {
    switch (promo.theme) {
      case "spring": return "bg-pink-600";
      case "summer": return "bg-cyan-600";
      case "fall": return "bg-orange-600";
      case "holiday": return "bg-red-700";
      case "newyear": return "bg-indigo-600";
      default: return "bg-primary";
    }
  };

  const isSpanish = typeof window !== 'undefined' && window.location.pathname.startsWith('/es/');
  const isRussian = typeof window !== 'undefined' && window.location.pathname.startsWith('/ru/');
  const isChinese = typeof window !== 'undefined' && window.location.pathname.startsWith('/zh/');
  
  let displayText = promo.bannerText;
  let ctaText = promo.ctaText;
  if (promo.id === 'spring-cleaning') {
    if (isSpanish) {
      displayText = "¡Especial de Limpieza de Primavera: Obtén $50 de descuento en una Limpieza Profunda!";
      ctaText = "Reclamar Oferta";
    } else if (isRussian) {
      displayText = "Весенняя акция: Скидка $50 на генеральную уборку!";
    } else if (isChinese) {
      displayText = "春季特惠：深度清洁立减$50！";
    }
  }

  return (
    <div className={`${getBgColor()} text-white px-4 py-3 relative z-50`}>
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 sm:gap-6 pr-8">
        <div className="flex items-center text-sm font-medium">
          {getIcon()}
          <span>{displayText}</span>
        </div>
        <Link 
          to="/promo" 
          className="text-xs font-bold uppercase tracking-wider bg-white/20 hover:bg-white/30 transition-colors px-3 py-1 rounded-full whitespace-nowrap"
        >
          {ctaText}
        </Link>
      </div>
      <button 
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Dismiss banner"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
